import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { translation } from '../../../i18n';
import { observer } from 'mobx-react';
import moment from 'moment';
import { BaseQuestionnaire } from '../../../pages/questionnaire/questionnaireTypes';

interface Props {
  questionnaire: BaseQuestionnaire,
  onStartClicked: () => void,
}

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit * 2,
    textAlign: 'left',
  },
  button: {
    textAlign: 'right'
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionnaireTitlePage extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props)
  }

  public render() {
    const {classes} = this.props;
    return (
      <Paper elevation={1} className={classes.root}>
        <Typography variant="h5">
          {this.props.questionnaire.title}
        </Typography>
        <br/>
        <Typography variant="body1">
          {this.props.questionnaire.description}
        </Typography>
        {
          this.props.questionnaire.anonymous &&
          <Typography variant="body1">
            {translation.t('questionnaireComponent.anonymous')}
          </Typography>
        }
        <Typography variant="body1">
          {translation.t('questionnaire.startDate')}: {moment(this.props.questionnaire.startDate).format('DD.MM.YYYY')}
        </Typography>
        <Typography variant="body1">
          {translation.t('questionnaire.endDate')}: {moment(this.props.questionnaire.endDate).format('DD.MM.YYYY')}
        </Typography>
        <Typography variant="body1">
          {translation.t('questionnaire.appraisee')}: {this.props.questionnaire.appraisee.firstName + ' ' + this.props.questionnaire.appraisee.lastName}
        </Typography>
        <Typography variant="body1">
          {translation.t('questionnaire.appraisers')}:
        </Typography>
        <ul>
          {
            this.props.questionnaire.appraisers.map(appraiser => (
              <li key={appraiser.id}>
                <Typography variant="body1">
                  {appraiser.firstName + ' ' + appraiser.lastName}
                </Typography>
              </li>
            ))
          }
        </ul>
        <div className={classes.button}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.onStartClicked}
          > Start </Button>
        </div>
      </Paper>
    )
  }
}

export default withStyles(localStyles)(QuestionnaireTitlePage);

